var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadge1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6696 16.0674H27.7006V2.50598H13.969V16.0674H1V30.4385H13.969V44H27.7006V30.4385H40.6696V16.0674Z",
    stroke: "#19223F",
    strokeWidth: 0.655825,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0001 13.5615H32.0311V0H18.2996V13.5615H5.33057V27.9326H18.2996V41.494H32.0311V27.9326H45.0001V13.5615Z",
    fill: "#19223F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0312 26H24.6172V19.3906C24.6172 19.2083 24.6198 18.9844 24.625 18.7188C24.6302 18.4479 24.638 18.1719 24.6484 17.8906C24.6589 17.6042 24.6693 17.3464 24.6797 17.1172C24.6224 17.1849 24.5052 17.3021 24.3281 17.4688C24.1562 17.6302 23.9948 17.776 23.8438 17.9062L22.5312 18.9609L21.3672 17.5078L25.0469 14.5781H27.0312V26Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge1);
export default __webpack_public_path__ + "static/media/Badge1.913094f1f928396312cd9d2ed18305af.svg";
export { ForwardRef as ReactComponent };